import { createSlice } from '@reduxjs/toolkit';
import { CM0023SliceType } from '../../entity/Entity';

export const initialState: CM0023SliceType = {
    isRefresh: false,
    isVisibleCM0023: false,
    isDisableRetrieveButton: true,
    documentId: null,
    documentInfo: {
        documentTitle: '',
        createdDate: '',
        targetPeriod: '',
        status: '',
    },
};

export const CM0023Slice = createSlice({
    name: 'CM0023',
    initialState,
    reducers: {
        resetCM0023: () => initialState,
        setVisibleCM0023: (state, action) => {
            state.isVisibleCM0023 = action.payload;
        },
        setDocumentIdCM0023: (state, action) => {
            state.documentId = action.payload;
        },
        setDocumentInfoCM0023: (state, action) => {
            state.documentInfo = action.payload;
        },
        setIsDisableRetrieveButtonCM0023: (state, action) => {
            state.isDisableRetrieveButton = action.payload;
        },
    },
});

export const {
    resetCM0023,
    setVisibleCM0023,
    setDocumentIdCM0023,
    setDocumentInfoCM0023,
    setIsDisableRetrieveButtonCM0023,
} = CM0023Slice.actions;

export default CM0023Slice.reducer;
